module.exports = __webpack_public_path__ + "images/icons_v2/upload-79f5b017.svg";